import { yupResolver } from '@hookform/resolvers/yup'
import React, { FC, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

import Spinner from '../../App/Components/Spinner/Spinner'
import { Button } from '../../Common/Button'
import { Flex } from '../../Common/Flex'
import { TextInput } from '../../Common/TextInput'
import { ErrorMessage } from '../../HealthInsuranceN/style'
import { validateVat } from '../subscriptionAPICall'

import { IBillingInformation } from './IBillingInformation'

const Form = Flex.withComponent('form')

const schema = yup
  .object({
    vat: yup.string().required().min(4),
  })
  .required()

type IVatFormData = yup.InferType<typeof schema>

export const VatForm: FC<{
  onVatValidated: (info: IBillingInformation) => void
}> = ({ onVatValidated }) => {
  const { t } = useTranslation()
  const textInputMargin = '10px 2px'

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isInvalid, setIsInvalid] = useState<boolean>(false)

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<IVatFormData>({
    resolver: yupResolver(schema),
    mode: 'onSubmit',
  })

  const onSubmit = async (data: IVatFormData) => {
    if (!data.vat) {
      return
    }

    setIsLoading(true)
    const result = await validateVat(data.vat)
    if (result.is_valid) {
      setIsInvalid(false)
      onVatValidated({
        vat: result.data.vat,
        name: result.data.name || '',
        address: result.data.address || '',
        postal: result.data.postal || '',
        location: result.data.location || '',
      })
    } else {
      setIsInvalid(true)
      setIsLoading(false)
    }
  }

  if (true === isLoading) {
    return <Spinner />
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Flex flexDirection={'column'}>
        {errors.vat || isInvalid ? (
          <ErrorMessage>{errors.vat?.message || t('Invalid vat')}</ErrorMessage>
        ) : null}
        <Controller
          name="vat"
          control={control}
          render={({ field }) => (
            <TextInput
              margin={textInputMargin}
              placeholder={t('Vat')}
              type="text"
              {...field}
            />
          )}
        />
        <div>
          <Button mt={3} type={'submit'} disabled={isLoading}>
            {t('Validate vat')}
          </Button>
        </div>
      </Flex>
    </Form>
  )
}
